// extracted by mini-css-extract-plugin
export var root = "Header-module--root--35hrx";
export var wrapper = "Header-module--wrapper--1c43D";
export var buttonsContainer = "Header-module--buttonsContainer--2y74c";
export var overlay = "Header-module--overlay--jgyvf";
export var smallIcon = "Header-module--smallIcon--3WVjF";
export var links = "Header-module--links--3cZB-";
export var active = "Header-module--active--1N9yZ";
export var loginContainer = "Header-module--loginContainer--1d0fR";
export var ham = "Header-module--ham--1pJ8Q";